import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { RoleService } from './@core/services/role.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  
  constructor(private authService: AuthService,
               private router: Router,
               private roleService: RoleService,) {}
  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }
  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // const userRole = this.roleService.getUserRole(); // Fetch user role from AuthService
    // const requiredRole = route.data['role']; // Access role required for the route
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const userRole = (sessionStorage.getItem('role') || '').trim();
      const requiredRole = next.data?.role;

      // If no specific role is required, allow access
      if (!requiredRole) {
        return true;
      }

      // If the user role matches the required role
      if (userRole && userRole === requiredRole) {
        return true;
      }

      // Case-insensitive matching
      if (userRole && userRole.toLowerCase() === requiredRole.toString().toLowerCase()) {
        return true;
      }

      // Technical Engineer matching
      const isUserTech = userRole.toLowerCase().includes('tech');
      const isReqTech = typeof requiredRole === 'string' && requiredRole.toLowerCase().includes('tech');
      if (isUserTech && isReqTech) {
        return true;
      }

      // Allow Admin, Manager, or Engineer to access Technical Dashboard as well
      if (isReqTech && ['admin', 'manager', 'engineer'].includes(userRole.toLowerCase())) {
        return true;
      }

      // If not, redirect to login
      this.router.navigate(['/login']);
      return false;
    }
  
}
